/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type RefetchResourceFaviconMutationVariables = Types.Exact<{
  resourceId: Types.Scalars['ID']['input'];
}>;


export type RefetchResourceFaviconMutation = { __typename: 'Mutation', refetchResourceFavicon?: { __typename: 'RefetchResourceFaviconMutation', resource?: { __typename: 'ResourceType', id: string, signedLogoUrl?: string | null } | null, errors?: Array<{ __typename: 'ErrorType', message?: string | null } | null> | null } | null };



export const RefetchResourceFaviconDocument = `
    mutation RefetchResourceFavicon($resourceId: ID!) {
  refetchResourceFavicon(resourceId: $resourceId) {
    resource {
      id
      signedLogoUrl
    }
    errors {
      message
    }
  }
}
    `;

export const useRefetchResourceFaviconMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefetchResourceFaviconMutation, TError, RefetchResourceFaviconMutationVariables, TContext>) => {
    
    return useMutation<RefetchResourceFaviconMutation, TError, RefetchResourceFaviconMutationVariables, TContext>(
      {
    mutationKey: ['RefetchResourceFavicon'],
    mutationFn: (variables?: RefetchResourceFaviconMutationVariables) => fetcher<RefetchResourceFaviconMutation, RefetchResourceFaviconMutationVariables>(RefetchResourceFaviconDocument, variables)(),
    ...options
  }
    )};


useRefetchResourceFaviconMutation.fetcher = (variables: RefetchResourceFaviconMutationVariables) => fetcher<RefetchResourceFaviconMutation, RefetchResourceFaviconMutationVariables>(RefetchResourceFaviconDocument, variables);
